"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TimelineFiltersStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFiltersStore"));

var TimelineTeamsFilterDependency = {
  stores: [_TimelineFiltersStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType;

    var teamFilters = _TimelineFiltersStore.default.get(objectType) && _TimelineFiltersStore.default.get(objectType).get('selectedTeams');

    return teamFilters || (0, _immutable.List)();
  }
};
var _default = TimelineTeamsFilterDependency;
exports.default = _default;
module.exports = exports.default;